
import Vue, { PropType } from 'vue';
import { Location } from 'vue-router';

export interface ProfileTab {
    icon: [string, string];
    label: string;
    to: string | Location;
}

export default Vue.extend({
    name: 'ProfileTabs',
    props: {
        tabs: {
            type: Array as PropType<ProfileTab[]>,
            required: false,
        },
    },
    data() {
        return {};
    },
    computed: {
        profileTabs(): ProfileTab[] {
            if (this.tabs) {
                return this.tabs;
            }

            const t = (id: string) => this.$t(`profile.tabs.${id}`).toString();

            return [
                {
                    icon: ['fal', 'user-vneck'],
                    label: t('profile'),
                    to: this.$URLS.profile,
                },
                {
                    icon: ['fal', 'files'],
                    label: t('documents'),
                    to: this.$URLS.profileDocuments,
                },
            ];
        },
    },
});
